export default __webpack_public_path__ + "static/media/10.d2bcf286.svg";